(function () {
  'use strict';
  function createPurchase(request, root) {
    var busy = false;
    return async function (items, sections) {
      if (busy) return { status: 'busy' };
      busy = true;
      var before;
      var definiteRejection = false;
      try {
        var initial = await request(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!initial.ok) return { status: 'rejected', message: 'Your cart could not be checked. Please try again.' };
        before = await initial.json();
        var response = await request(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: sections || [], sections_url: root })
        });
        var data = await response.json();
        if (!response.ok) { definiteRejection = response.status >= 400 && response.status < 500; throw new Error(data.description || 'Your kit could not be added.'); }
        return { status: 'added', data: data };
      } catch (error) {
        if (!before) return { status: 'rejected', message: 'Your cart could not be checked. Please try again.' };
        var cart = null;
        try {
          var check = await request(root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (check.ok) cart = await check.json();
        } catch (_) { /* An uncertain request must never be automatically retried. */ }
        var changed = !cart || items.some(function (item) {
          function quantity(state) { return state.items.filter(function (line) { return Number(line.variant_id) === Number(item.id); }).reduce(function (n, line) { return n + line.quantity; }, 0); }
          return quantity(cart) !== quantity(before);
        });
        return { status: definiteRejection && !changed ? 'rejected' : 'review', cart: cart, message: error.message };
      } finally { busy = false; }
    };
  }
  function initKit(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var form = root.querySelector('[data-kit-form]');
    var button = root.querySelector('[data-kit-submit]');
    var total = root.querySelector('[data-kit-total]');
    var status = root.querySelector('[data-kit-status]');
    var fields = root.querySelector('[data-kit-fields]');
    var review = root.querySelector('[data-kit-review]');
    var pending = false, locked = false;
    var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var purchase = createPurchase(window.fetch.bind(window), shopRoot);
    var cards = Array.from(root.querySelectorAll('[data-kit-card]')).map(function (el) {
      return { el: el, products: JSON.parse(el.querySelector('[data-kit-products]').textContent), productSelect: el.querySelector('[data-kit-product]'), include: el.querySelector('[data-kit-include]'), options: el.querySelector('[data-kit-options]'), variant: null };
    });
    function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100); }
    function current(card) { return card.products.find(function (p) { return String(p.id) === card.productSelect.value; }); }
    function image(card, product, variant) {
      var img = card.el.querySelector('img');
      var source = variant && variant.featured_image ? variant.featured_image.src : product.featured_image;
      if (img && source) {
        var url = new URL(source, location.origin); url.searchParams.set('width', '540');
        if (img.src !== url.href) { img.removeAttribute('srcset'); img.src = url.href; }
        img.alt = product.title;
      }
      var suffix = variant ? '?variant=' + variant.id : '';
      card.el.querySelector('[data-kit-link]').href = shopRoot + 'products/' + product.handle + suffix;
      card.el.querySelector('[data-kit-link]').setAttribute('aria-label', 'View ' + product.title);
      card.el.querySelector('[data-kit-details]').href = shopRoot + 'products/' + product.handle + suffix;
    }
    function renderOptions(card) {
      var product = current(card);
      card.options.replaceChildren();
      if (!(product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
        product.options.forEach(function (option, index) {
          var name = typeof option === 'string' ? option : option.name;
          var label = document.createElement('label'); label.textContent = name;
          var select = document.createElement('select');
          select.setAttribute('aria-label', product.title + ' ' + name);
          select.add(new Option('Choose ' + name.toLowerCase(), ''));
          Array.from(new Set(product.variants.map(function (v) { return v.options[index]; }))).forEach(function (value) { select.add(new Option(value, value)); });
          label.append(select);card.options.append(label);
        });
      }
      sync();
    }
    function sync() {
      var chosen = [], incomplete = false, amount = 0;
      cards.forEach(function (card) {
        var product = current(card);
        if (!product.available) card.include.checked = false;
        card.include.disabled = !product.available;
        card.options.hidden = !card.include.checked;
        var selects = Array.from(card.options.querySelectorAll('select'));
        var values = selects.map(function (s) { return s.value; });
        selects.forEach(function (select, index) {
          select.disabled = !card.include.checked;
          Array.from(select.options).forEach(function (option) {
            if (!option.value) return;
            var possible = product.variants.some(function (variant) {
              return variant.available && variant.options[index] === option.value && values.every(function (value, i) { return i === index || !value || variant.options[i] === value; });
            });
            option.textContent = option.value + (possible ? '' : ' · Unavailable');
          });
        });
        card.variant = selects.length ? product.variants.find(function (variant) { return variant.options.every(function (value, index) { return value === values[index]; }); }) : product.variants[0];
        card.el.querySelector('[data-kit-price]').textContent = money(card.variant ? card.variant.price : product.price) + (!card.variant && product.price_varies ? '+' : '');
        var message = !product.available ? 'Sold out. Choose another piece.' : '';
        if (card.include.checked) {
          chosen.push(card);
          if (!card.variant) { incomplete = true; message = 'Choose your options to include this piece.'; }
          else if (!card.variant.available) { incomplete = true; message = 'This combination is unavailable. Choose another option.'; }
          else { amount += card.variant.price; message = 'Available'; }
        }
        card.el.querySelector('[data-kit-availability]').textContent = message;
        image(card, product, card.variant);
      });
      total.textContent = chosen.length ? incomplete ? 'Finish choosing your options' : chosen.length + (chosen.length === 1 ? ' piece · ' : ' pieces · ') + money(amount) : 'Choose your pieces';
      button.disabled = pending || locked || !chosen.length || incomplete;
      return chosen;
    }
    cards.forEach(function (card) {
      card.productSelect.addEventListener('change', function () { renderOptions(card); status.textContent = ''; });
      card.include.addEventListener('change', sync);
      card.options.addEventListener('change', sync);
      renderOptions(card);
    });
    root.querySelectorAll('[data-kit-enhanced]').forEach(function (el) { el.hidden = false; });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var chosen = sync();
      if (button.disabled || pending || locked) return;
      pending = true;fields.disabled = true;button.disabled = true;button.textContent = 'Adding your selections…';
      status.textContent = '';review.hidden = true;
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var result = await purchase(chosen.map(function (card) { return { id: card.variant.id, quantity: 1 }; }), sections);
      pending = false;fields.disabled = false;button.textContent = 'Add selections to cart';
      if (result.status === 'added') {
        cards.forEach(function (card) { card.include.checked = false; });
        status.textContent = 'Your selections were added to the cart.';
        if (drawer && result.data.sections && sections.every(function (id) { return result.data.sections[id]; })) {
          try { drawer.setActiveElement(button);drawer.classList.remove('is-empty');drawer.renderContents(result.data); }
          catch (_) { location.assign(shopRoot + 'cart'); }
        } else { location.assign(shopRoot + 'cart'); }
      } else if (result.status === 'review') {
        locked = true;status.textContent = 'We could not confirm the full kit. Some pieces may have been added. Review your cart before adding more.';review.hidden = false;review.focus();
      } else { status.textContent = result.message || 'Your selections could not be added. Please try again.'; }
      sync();
    });
    sync();
  }
  if (typeof document !== 'undefined') {
    var initialize = function () { document.querySelectorAll('[data-course-kit]').forEach(initKit); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
    document.addEventListener('shopify:section:load', initialize);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createPurchase: createPurchase };
})();
